<script lang="ts">
	import ShellLayout from "./ShellLayout.svelte";
	import PublishPresentation from "./PublishPresentation.svelte";
	let { params = { id: "" } }: { params: { id: string } } = $props();
</script>

<ShellLayout><PublishPresentation presentationId={params.id} /></ShellLayout>
